<template>
  <v-app>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  name: 'App'
}
</script>
<style>
@media print {
  html, body {
    border: 1px solid white;
    height: 99% !important;
    page-break-after: avoid !important;
    page-break-before: avoid !important;
  }
}
.theme--light.application {
  background: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue